import $ from 'jquery'

$(function () {
  // This purposefully ignored cases with multiple text nodes
  // We're aiming at simple form artifacts, that tend to have
  // one text node. E.g. hint container, label.
  const setTextValue = function (element, value = '') {
    const textNode = document
      .createNodeIterator(element, NodeFilter.SHOW_TEXT)
      .nextNode()
    if (textNode) {
      textNode.nodeValue = value
    } else {
      element.appendChild(document.createTextNode(value))
    }
  }

  const reactiveVisibilityToggler = function (hintHolder, copyOnly, value) {
    const hint = hintHolder.querySelector('.hint')
    if (!hint) {
      return
    }
    const copy = hintHolder.dataset[value]

    if (copyOnly === 'true') {
      return setTextValue(hint, copy)
    }

    if (copy) {
      setTextValue(hint, copy)
      hintHolder.classList.remove('sf-hidden')
      for (const input of hintHolder.querySelectorAll('input')) {
        if (!input.classList.contains('disabled')) {
          input.removeAttribute('disabled')
        }
      }
    } else {
      hintHolder.classList.add('sf-hidden')
      for (const input of hintHolder.querySelectorAll('input')) {
        if (!input.classList.contains('disabled')) {
          input.setAttribute('disabled', 'disabled')
        }
      }
    }
  }

  // Add 'hint-copy-only' => 'true' when not all possibles values of the input have a hint
  const attachHintMonitors = function () {
    for (const monitor of document.querySelectorAll('[data-hint-monitor]')) {
      const watching = monitor.dataset['hintMonitor']
      const copyOnly = monitor.dataset['hintCopyOnly']

      // .on and .off with additional selector
      // are kinda tricky in vanilla JS,
      // so jQuery it is
      $(document).off('change', watching)
      $(document).on('change', watching, (e) =>
        reactiveVisibilityToggler(monitor, copyOnly, e.currentTarget.value)
      )

      updateHints(watching, monitor, copyOnly)
    }
  }

  const updateHints = function (valueSelector, hintHolder, copyOnly) {
    const valueTarget = document.querySelector(valueSelector)
    if (valueTarget) {
      return reactiveVisibilityToggler(hintHolder, copyOnly, valueTarget.value)
    }
  }

  attachHintMonitors()

  document.addEventListener('turbolinks:load', () => attachHintMonitors())
})
